export default __webpack_public_path__ + "static/loops-0d997543636e862e93eb87165b2bdca6.svg";